import { api } from "../../api";
import * as types from "../types";
import {fundApi} from "@/views/Account Management/Funding/services/FUND-api.service";
import { ACTION_GET_ADVISOR_ACCOUNTS, MUTATION_SET_ADVISOR_ACCOUNTS } from "./types";

export default {
    [types.FUND_ACT_BULK_GET_PENDING_DEPOSIT_ATTRIBUTIONS]: (context, accountIds) => {
        return api.bulkGetPendingDepositAttributionsForAccountHolder(accountIds).then(
            (result) => context.commit(types.FUND_MUTATION_BULK_SET_PENDING_DEPOSIT_ATTRIBUTIONS, result.data),
            (_e) => context.commit(types.FUND_MUTATION_BULK_SET_PENDING_DEPOSIT_ATTRIBUTIONS, [])
        )
    },
    [types.FUND_ACT_GET_CLIENT_TRADING_ACCOUNTS]: (context, accountHolderId) => {
        return api.getClientTradingAccounts(accountHolderId).then(
            (result) => context.commit(types.FUND_MUTATION_SET_CLIENT_TRADING_ACCOUNTS, result.data),
            (_e) => context.commit(types.FUND_MUTATION_SET_CLIENT_TRADING_ACCOUNTS, [])
        )
    },
    [ACTION_GET_ADVISOR_ACCOUNTS]: async (context) => {
        if (context.state.advisorAccounts && context.state.advisorAccounts.length > 0) {
            // If advisor accounts are already loaded, no need to fetch again
            return context.state.advisorAccounts;
        }

        try {
            const response = await fundApi.getTradingAccounts();
            context.commit(MUTATION_SET_ADVISOR_ACCOUNTS, response.data);
            return response.data;
        } catch (error) {
            context.commit(MUTATION_SET_ADVISOR_ACCOUNTS, []);
        }
    }
}
